import { useEffect, useState } from "react";
import { t } from "i18next";
import _ from "lodash";

import { Tab } from "../../../../../stores/TabsStore";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../../ui/Tabs/Tabs";
import { Separator } from "../../../../../ui/Separator";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";

import { LoadBarChart } from "./LoadBarChart";
import { EquipmentInteractions } from "./EquipmentInteractions";
import Comparative from "./Comparative";
import { PersonsLoaded } from "./PersonsLoaded";

export function TemplateSummary({tab}:{tab: Tab}) {
  const [loading, setLoading] = useState(true)
  const [itemData, setItemData] = useState(tab.options?.reportData)

  useEffect(() => {
    if(tab.reportOptions.type === "summary") {
      return
    }
    setLoading(true)
    setItemData(_.orderBy(tab.options?.reportData, el => el.dateShift.start_day, "desc"))
  }, [tab.reportOptions.items])

  useEffect(() => {
    setLoading(false)
  }, [itemData])

  return (
    <div className="flex flex-col w-full h-full overflow-hidden">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('summary_report')}</span>
        </div>
      </div>
      
      <Separator />
      {loading ? <></> :
      <Tabs defaultValue={"common"} className="flex flex-col bg-background relative h-full w-full overflow-hidden">
        <TabsList className="flex-none h-12 w-full px-6 justify-start gap-2">
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="common">
            {t("common_info")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="comparative">
            {t("comparative")}
          </TabsTrigger>
          {/* <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="losses">
            {t("losses")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="violations">
            {t("violations")}
          </TabsTrigger> */}
        </TabsList>
        <Separator />
        <div className="flex flex-col w-full h-full justify-start relative overflow-hidden">
          <TabsContent className="flex flex-col min-w-[1008px] w-full data-[state=active]:h-full m-0" value="common">
            <ScrollArea>
              <div className="flex flex-col gap-2">
                <div className="px-6">
                  <PersonsLoaded data={itemData!}/>
                </div>
                <div className="px-6 space-y-2">
                  <LoadBarChart data={itemData!}/>
                </div>
                <div className="px-6 h-full">
                  <EquipmentInteractions data={itemData!} />
                </div>
              </div>
            </ScrollArea>
          </TabsContent>
          <TabsContent className="flex flex-col w-full min-w-[808px] data-[state=active]:h-full m-0" value="comparative">
            <ScrollArea>
              <div className="px-6 space-y-2">
                <Comparative data={itemData!} tab={tab}/>
              </div>
            </ScrollArea>
          </TabsContent>
        </div>
      </Tabs>}

    </div>
  )
}